import Alert from '@/presentation/components/ui/Alert';

interface ZeroNftsAlertProps {
  count: number;
}

export const ZeroNftsAlert = ({ count }: ZeroNftsAlertProps) => {
  if (count !== 0) return null;

  return <Alert>You have {count} NFTs selected currently</Alert>;
};
